import { i18nInstance } from 'i18n/index';
import { NUMERAL_FORMAT_STR_REGEX, setNumeralLocale } from 'i18n/numeral';
import { FormatFunction } from 'i18next';
import numeral from 'numeral';
import { DateTime } from 'luxon';

type LuxonPresets = 'DATETIME_FULL' |
'DATETIME_FULL_WITH_SECONDS'|
'DATETIME_HUGE'|
'DATETIME_HUGE_WITH_SECONDS'|
'DATETIME_MED'|
'DATETIME_MED_WITH_SECONDS'|
'DATETIME_SHORT'|
'DATETIME_SHORT_WITH_SECONDS'|
'DATE_FULL'|
'DATE_HUGE'|
'DATE_MED'|
'DATE_MED_WITH_WEEKDAY'|
'DATE_SHORT'|
'TIME_24_SIMPLE'|
'TIME_24_WITH_LONG_OFFSET'|
'TIME_24_WITH_SECONDS'|
'TIME_24_WITH_SHORT_OFFSET'|
'TIME_SIMPLE'|
'TIME_WITH_LONG_OFFSET'|
'TIME_WITH_SECONDS'|
'TIME_WITH_SHORT_OFFSET';

function formatWithLuxon(value: DateTime | Date, format?: string) {
  let preset = DateTime[format as LuxonPresets];

  if (format && !preset) {
    try {
      preset = JSON.parse(format);
    // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  const dateTime = value instanceof DateTime ? value.setLocale(i18nInstance.language) : DateTime.fromJSDate(value);

  if (typeof preset === 'object' && !!preset) return dateTime.toLocaleString(preset);

  return format ? dateTime.toFormat(format) : dateTime.toLocaleString();
}

// See https://www.i18next.com/translation-function/formatting
export const formatter: FormatFunction = (value, format, lng = i18nInstance.language) => {
  if (value === undefined || value === null) return value;

  if (value instanceof Date || value instanceof DateTime) {
    return formatWithLuxon(value, format);
  }

  // Use Numeral.js
  if (format && NUMERAL_FORMAT_STR_REGEX.test(format)) {
    const initialLocale = numeral.locale();
    setNumeralLocale(lng);
    try {
      return numeral(value).format(format);
    } finally {
      numeral.locale(initialLocale);
    }
  }

  // If we have a format string but don't recognize it
  if (format) {
    console.error(`Unrecognized i18n interpolation format '${format}'.\nSee http://numeraljs.com/ for valid format strings.`);
  }

  return value;
};
